import { saveAs } from "file-saver"

function parseJSON(responseObj) {
  if (responseObj.status === 204 || responseObj.status === 205) {
    return null
  }
  return responseObj.json()
}

const sendError = responseObj => {
  const error = new Error(responseObj.statusText)
  error.response = responseObj
  throw error
}

const is200Resp = responseObj => {
  if (responseObj && responseObj.status !== undefined) {
    return responseObj.status === 200
  }
  return false
}

const statusIsOK = status => {
  if (status === undefined || typeof status !== "number") return false
  return isBetween(status, 200, 300)
}

const isBetween = (value, min, max) => {
  return min <= value && value <= max
}

//Returns either the response, or throws an error
function checkResponseStatus(responseObj) {
  const { status } = responseObj
  if (statusIsOK(status)) return responseObj
  sendError(responseObj)
}

export default function request(url, optionsObj) {
  // console.log(url, optionsObj)
  return fetch(url, optionsObj).then(checkResponseStatus).then(parseJSON)
}

export const etlRequest = async (url, optionsObj) => {
  const response = await fetch(url, optionsObj)
  const jsonRep = await response.json()
  const status = response.status
  if (!statusIsOK(status)) {
    var errorCode = jsonRep?.app_code ? jsonRep.app_code : "ERROR"
    var error = { body: jsonRep, type: "error", code: errorCode }
    return error
  }
  return jsonRep
}

const getBlob = (response, downloadType) => {
  if (is200Resp(response)) {
    return response.blob()
  }
  var blob = new Blob([], { type: "application/csv" })
  return blob
}

const downloadFile = (blob, sourceName, downloadType) => {
  var extension = ""
  if (downloadType === "csv") extension = ".csv"
  else if (downloadType === "excel") extension = ".xlsx"

  var finalFileName = `${sourceName}${extension}`
  saveAs(blob, finalFileName)
}

export const requestSourceFilesAndDownload = async (options, headers) => {
  const { url, sourceName, downloadType } = options
  var response = await fetch(url, headers)
  var blob = await getBlob(response)
  var downloadResult = await downloadFile(blob, sourceName, downloadType)
  return downloadResult
}

export const requestFilesAndDownload = async (options, headers) => {
  const { url, fileName } = options
  var response = await fetch(url, headers)
  var blob = await getBlob(response)
  saveAs(blob, fileName)
  return response
}

export const requestFile = async (url, headers) => {
  var response = await fetch(url, headers)
  var blob = await getBlob(response)
  return { blob, response }
}
